if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const sectionUrl = `${this.dataset.productUrl.split('?')[0]}?section_id=${sectionId}`;
        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            this.setInnerHTML(drawerContent, productElement.content.cloneNode(true));
            FoxTheme.a11y.trapFocus(this, this.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            setTimeout(() => {
              this.classList.add(this._classes.loaded);
            }, 300);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        // Only run hide cleanup if it was actually open. Otherwise removing a
        // never-opened quick view from the DOM (e.g. when predictive search
        // swaps in new results) would decrement the shared modal lock counter
        // and wrongly unlock the page while another modal (search drawer) is open.
        if (this.open) this.handleAfterHide();
      }
    }
  );
}

/*
  BSD 10-24 测速（svgqv）：商品卡不再预渲染 quick-view-modal 外壳。
  第一次点带 data-bsd-qv-url 的按钮（放大镜 / Choose options）时：按需加载弹窗样式表，创建和原 snippets/quick-view-modal.liquid
  一样的外壳，放回这张卡里，然后调用 show()；弹窗内容仍由上面的 quickview() 通过 Section Rendering API 拉取。
  之后的点击由弹窗自己在 connectedCallback 里绑定的监听处理。脚本未加载 / 无 JS 时，Choose options 是普通链接，直接进商品页。
*/
(() => {
  if (window.BSDQuickViewLazy) return;
  window.BSDQuickViewLazy = true;

  const closeSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close icon--medium" fill="none" viewBox="0 0 24 24"><path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const spinnerSvg =
    '<svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle></svg>';
  const esc = (value) =>
    String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const sprite = () => document.getElementById('bsd-icon-sprite');

  const fileName = (url) => url.split('?')[0].split('/').pop();
  const ensureStyles = () => {
    const holder = sprite();
    const urls = holder && holder.dataset.qvCss ? holder.dataset.qvCss.split(' ').filter(Boolean) : [];
    const loaded = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map((link) => fileName(link.href));
    const waits = urls
      .filter((url) => !loaded.includes(fileName(url)))
      .map(
        (url) =>
          new Promise((resolve) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.onload = resolve;
            link.onerror = resolve;
            document.head.appendChild(link);
          })
      );
    if (!waits.length) return Promise.resolve();
    return Promise.race([Promise.all(waits), new Promise((resolve) => setTimeout(resolve, 3000))]);
  };

  // <a role="button"> 也要像原来的 <button> 一样支持空格键
  document.addEventListener('keydown', (event) => {
    if (event.key !== ' ' && event.code !== 'Space') return;
    const button = event.target.closest && event.target.closest('a[role="button"][data-bsd-qv-url]');
    if (!button) return;
    event.preventDefault();
    button.click();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-bsd-qv-url][aria-controls]');
    if (!button) return;
    const modalId = button.getAttribute('aria-controls');
    if (!modalId || document.getElementById(modalId)) return; // 已创建：弹窗自己的点击监听会处理
    event.preventDefault();
    if (button.hasAttribute('data-bsd-qv-pending')) return;
    button.setAttribute('data-bsd-qv-pending', '');

    const holder = sprite();
    const closeLabel = (holder && holder.dataset.closeLabel) || 'Close';
    const id = esc(modalId);
    const template = document.createElement('template');
    template.innerHTML =
      `<quick-view-modal id="${id}" class="quick-view drawer drawer--right" data-product-url="${esc(button.dataset.bsdQvUrl)}" hidden>` +
      `<div class="fixed-overlay" aria-controls="${id}"></div>` +
      `<div class="drawer__inner"><button class="drawer__close-btn" aria-controls="${id}" aria-label="${esc(closeLabel)}">${closeSvg}</button>` +
      `<div class="loading__spinner hidden">${spinnerSvg}</div>` +
      `<div class="drawer__body v-scrollable h-full quick-view__content"></div></div></quick-view-modal>`;
    const modal = template.content.firstElementChild;

    ensureStyles().then(() => {
      button.removeAttribute('data-bsd-qv-pending');
      if (document.getElementById(modalId)) return;
      (button.closest('.product-card') || document.body).appendChild(modal);
      if (typeof modal.show === 'function') {
        modal.show(button);
      } else {
        window.location.href = button.dataset.bsdQvUrl;
      }
    });
  });
})();
